module.exports = __webpack_public_path__ + "img/visa.97cfa0b6.png";